/* Live header search (Omah Lempung) — results appear while typing, via Shopify predictive search. */
(function () {
  'use strict';
  if (window.OLSearch) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};
  var DELAY = 160;

  function sectionHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var c = doc.querySelector('[data-ps-content]');
    return c ? c.outerHTML : '';
  }
  function urlFor(q) {
    if (!q) return root + '?section_id=predictive-search';
    return root + 'search/suggest?q=' + encodeURIComponent(q) +
      '&section_id=predictive-search' +
      '&resources[type]=product,collection,query,page' +
      '&resources[limit]=8&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
  }

  function setup(details) {
    if (!details || details._ps) return;
    details._ps = true;
    var panel = details.querySelector('.search-modal__panel');
    var form = details.querySelector('form');
    var input = details.querySelector('input[type="search"]');
    if (!panel || !form || !input) return;

    var wrap = document.createElement('div');
    wrap.className = 'ps-wrap page-width';
    wrap.id = 'PsResults';
    wrap.innerHTML = '<span class="ps-bar" aria-hidden="true"></span><div class="ps-out" data-ps-out></div><p class="visually-hidden" data-ps-status role="status" aria-live="polite"></p>';
    panel.appendChild(wrap);
    panel.classList.add('ps-panel');
    var out = wrap.querySelector('[data-ps-out]');
    var status = wrap.querySelector('[data-ps-status]');

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', 'PsResults');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('enterkeyhint', 'search');

    var timer = 0, ctrl = null, current = null, active = -1;

    function render(q, html) {
      if (q !== current) return;
      out.innerHTML = html;
      active = -1;
      wrap.classList.remove('is-loading');
      wrap.classList.toggle('has-query', !!q);
      input.setAttribute('aria-expanded', 'true');
      var box = out.querySelector('[data-ps-content]');
      var n = box ? parseInt(box.getAttribute('data-ps-count'), 10) : -1;
      status.textContent = q ? (n > 0 ? n + ' products found' : 'No products found') : '';
      // replay the gentle entrance for the new results
      out.classList.remove('is-in'); void out.offsetWidth; out.classList.add('is-in');
    }
    function load(q) {
      current = q;
      if (cache[q] != null) { render(q, cache[q]); return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      wrap.classList.add('is-loading');
      fetch(urlFor(q), ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) { var h = sectionHtml(t); cache[q] = h; render(q, h); })
        .catch(function (e) { if (e && e.name === 'AbortError') return; if (q === current) wrap.classList.remove('is-loading'); });
    }
    function update() {
      var q = input.value.trim();
      clearTimeout(timer);
      timer = setTimeout(function () { load(q); }, q ? DELAY : 0);
    }

    function items() { return Array.prototype.slice.call(out.querySelectorAll('[data-ps-item]')).filter(function (a) { return a.offsetParent !== null; }); }
    function move(dir) {
      var list = items();
      if (!list.length) return;
      if (active > -1 && list[active]) list[active].removeAttribute('aria-selected');
      active = active + dir;
      if (active < -1) active = list.length - 1;
      if (active >= list.length) active = -1;
      if (active === -1) { input.removeAttribute('aria-activedescendant'); return; }
      var el = list[active];
      if (!el.id) el.id = 'ps-opt-' + active + '-' + Date.now();
      el.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', el.id);
      el.scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('input', update);
    input.addEventListener('focus', function () { if (current === null) load(input.value.trim()); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Enter' && active > -1) {
        var el = items()[active];
        if (el) { e.preventDefault(); window.location.href = el.href; }
      }
    });
    // a popular-search chip fills the box and shows its results right here
    out.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('[data-ps-term]');
      if (!chip) return;
      e.preventDefault();
      input.value = chip.getAttribute('data-ps-term');
      input.focus();
      load(input.value.trim());
    });
    details.addEventListener('toggle', function () {
      document.documentElement.classList.toggle('ps-open', details.open);
      if (details.open) { if (current === null || current !== input.value.trim()) load(input.value.trim()); }
      else { input.setAttribute('aria-expanded', 'false'); }
    });
    // warm up the empty state so it is ready the moment the panel opens
    var summary = details.querySelector('summary');
    if (summary) {
      var warm = function () {
        if (cache[''] != null) return;
        fetch(urlFor('')).then(function (r) { return r.text(); }).then(function (t) { cache[''] = sectionHtml(t); }).catch(function () {});
      };
      summary.addEventListener('pointerenter', warm, { once: true });
      summary.addEventListener('touchstart', warm, { once: true, passive: true });
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('details[data-search-modal]'), setup); }
  window.OLSearch = { setup: setup };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();